import { addLead } from '../fire'
import Dropdown from './Dropdown'

let PartnerManuallyAddLeadBtn = ({ month, partnerClientIds }) => (
  <Dropdown
    className="ml-auto"
    tag="span"
    align="right"
    trigger={
      <button className="btn btn-secondary btn-sm">
        <i className="fa fa-plus" /> Manually Add Lead
      </button>
    }
  >
    {partnerClientIds.map(clientId => (
      <button
        key={clientId}
        className="dropdown-item small"
        onClick={() => addLead({ month, clientId })}
      >
        {clientId}
      </button>
    ))}
  </Dropdown>
)

export default PartnerManuallyAddLeadBtn
